export const apiName: string = 'cores';

export const coresQuery: any = {
    "where":{
      "ativo":true,
      "cor":{"regexp":"/REPLACEHERE/i"}
    },
    "order":"cor"
  };



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/cores/data.service.ts
 **/